/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  sharePreviewCard: css`
    padding: 15px;
    border: 1px solid var(--cds-color-grey-300);
    border-radius: 4px;
    margin-bottom: 25px;
    margin-top: -5px;
  `,
  sharePreviewCardContainer: css`
    display: flex;
  `,
  sharePreviewCardImage: css`
    object-fit: cover;
    width: 100%;
    height: 100%;
  `,
  sharePreviewCardPlayIcon: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  `,
  sharePreviewCardTitle: css`
    margin: 0 0 4px 0;
  `,
  sharePreviewCardPartner: css`
    line-height: 1.075rem;
    margin: 0;
  `,
  sharePreviewCardLeftCol: css`
    flex-basis: 90px;
    height: 50px;
    margin-right: 15px;
    position: relative;

    &::after {
      content: '';
      background: rgb(0 0 0 / 15%);
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  `,
};

type Props = {
  title: string;
  partnerName?: string | null;
  imageSrc?: string;
};

export default ({ title, partnerName, imageSrc }: Props) => {
  return (
    <div css={styles.sharePreviewCard}>
      <div css={styles.sharePreviewCardContainer}>
        <div css={styles.sharePreviewCardLeftCol}>
          {imageSrc && <img src={imageSrc} alt={`${title} preview`} css={styles.sharePreviewCardImage} />}
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            css={styles.sharePreviewCardPlayIcon}
          >
            <g opacity="0.841355">
              <path fillRule="evenodd" clipRule="evenodd" d="M1.83325 0V22L20.6249 11L1.83325 0Z" fill="black" />
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="1" y="0" width="20" height="22">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.83325 0V22L20.6249 11L1.83325 0Z" fill="white" />
              </mask>
              <g mask="url(#mask0)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 0H22V22H0V0Z"
                  fill="var(--cds-color-neutral-primary-invert)"
                />
              </g>
            </g>
          </svg>
        </div>
        <div>
          <Typography2 variant="subtitleMedium" component="h5" css={styles.sharePreviewCardTitle}>
            {title}
          </Typography2>
          <Typography2 variant="bodySecondary" component="p" css={styles.sharePreviewCardPartner}>
            {partnerName}
          </Typography2>
        </div>
      </div>
    </div>
  );
};
